// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__nA9XN","actions":"Hero_actions__vPvwo"};